import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/chipgpt/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/chipgpt/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"montserrat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/oscararmstrong/node/chipgpt/src/app/_components/Providers.tsx");
;
import(/* webpackMode: "eager" */ "/Users/oscararmstrong/node/chipgpt/src/app/globals.css");
